import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   		from 'FactoryService.js';
import constants        		from 'Constants.js';
import sequenceService  		from 'SequenceService.js';

import ControlModel    			from 'ControlModel.js';
import WebSignatureControlView 		from 'advanced-inputs/WebSignatureControlView.js';

//=============================================================================
//
// Creates a web signature control, given a factoryService
// parameter key and a layout position. The factory key defines the initial
//
// Alfonso Cabral, March 11, 2016
//
//=============================================================================
class ControlWebSignatureFactory extends BaseVisualControlFactory {
	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
		attributes.clear = 'Clear';
		attributes.cornerRadius = 4;
		attributes.borderColor = '#ABABAB';

		attributes.buttonTextColor ='~buttonTextColor';
		attributes.styleColorTextDown ='~buttonTextDownColor';
		attributes.styleColorTextOver ='~buttonTextOverColor';
		attributes.buttonFontFamily = '~buttonFont';
		attributes.buttonFontSize = '~buttonFont';
		attributes.buttonTextWeight = '~buttonFont';
		attributes.buttonTextStyle  = '~buttonFont';
		attributes.buttonBackgroundColor = '~buttonBgColor';
		attributes.buttonBackgroundGradientColor = '~buttonBgGradientColor';
		attributes.backgroundColor = '~inputBgColor';
		attributes.advancedBgGradientColor = '~buttonBgGradientColor';
		attributes.bgGradientColor= '~buttonBgGradientColor';
		attributes.position = 'bottom';
		attributes.buttonPosition = 'unchecked';
		attributes.buttonLabelSave = 'Save';
		attributes.buttonLabelClear = 'Clear';
		attributes.buttonPositionAbove = 'false';
		attributes.imageBackgroundColor = '#FFFFFF';
		attributes.signatureColor = '#000000';
        attributes.resizePadding = 2;
        attributes.imageBackgroundColor = '#FFFFFF';
		attributes.minWidth = 10;
		attributes.lowestHeight = 140;
        this.resolveForInitialMinHeight(attributes);
		attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
			{key:"buttonLabelSave", label:"Save Button"},
			{key:"buttonLabelClear", label:"Clear Button"}
        ];

		return new WebSignatureControlView( { model: new ControlModel( attributes ), el: $(constants.FORM_ID),
            							pos: pos, factoryKey: factoryKey, id: attributes.id } );
	}

}

const controlWebSignatureFactory = new ControlWebSignatureFactory();
export default controlWebSignatureFactory;
